import React, { useEffect, useState } from "react";

const SUN =
  "M12 3v2m0 14v2M5.2 5.2l1.4 1.4m10.8 10.8l1.4 1.4M3 12h2m14 0h2M5.2 18.8l1.4-1.4M17.4 6.6l1.4-1.4M12 8a4 4 0 100 8 4 4 0 000-8z";
const MOON =
  "M21 12.8A9 9 0 1111.2 3 7 7 0 0021 12.8z";

export function getInitialTheme(): "light" | "dark" {
  try {
    const saved = localStorage.getItem("theme");
    if (saved === "dark" || saved === "light") return saved;
  } catch {}
  return "light";
}

export function applyTheme(theme: "light" | "dark") {
  document.documentElement.classList.toggle("dark", theme === "dark");
  try {
    localStorage.setItem("theme", theme);
  } catch {}
  window.dispatchEvent(new CustomEvent("xt-theme", { detail: theme }));
}

export const useIsDark = () => {
  const [isDark, setIsDark] = useState(
    () => document.documentElement.classList.contains("dark")
  );
  useEffect(() => {
    const onChange = (e: Event) =>
      setIsDark((e as CustomEvent).detail === "dark");
    window.addEventListener("xt-theme", onChange);
    return () => window.removeEventListener("xt-theme", onChange);
  }, []);
  return isDark;
};

const ThemeToggle: React.FC = () => {
  const isDark = useIsDark();
  return (
    <button
      onClick={() => applyTheme(isDark ? "light" : "dark")}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      className="w-7 h-7 flex items-center justify-center rounded-lg text-gray-400 hover:text-gray-50 hover:bg-gray-800 shrink-0 transition-all"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-4 h-4"
      >
        <path d={isDark ? SUN : MOON} />
      </svg>
    </button>
  );
};

export default ThemeToggle;
